import { initializeApp, getApps } from 'firebase/app';
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from 'firebase/app-check';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getFunctions } from 'firebase/functions';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyCe91qVYFEU7RpXkcZ8XK12ziA8lQpQ_EM",
  authDomain: "maldivesride-1536a.firebaseapp.com",
  projectId: "maldivesride-1536a",
  storageBucket: "maldivesride-1536a.firebasestorage.app",
  messagingSenderId: "987576426260",
  appId: "1:987576426260:web:9645ecc681b454deaf6c01"
};

const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];

/**
 * App Check for the admin panel.
 *
 * The mobile apps attest with App Attest and Play Integrity; this web app sent
 * no token at all, which was fine only because every Firebase service is on
 * Monitoring. The day anything is set to Enforced, an unregistered admin panel
 * stops working — and it is the tool used to verify users and bikes, edit the
 * remote config that tells users to update, and unstick bookings. Losing it
 * during an enforcement incident means losing the means to respond to one.
 *
 * Initialised immediately after the app and before any service handle, so
 * tokens are attached to the very first Firestore read.
 *
 * SETUP (one-off, in the Firebase Console):
 *   1. App Check → Apps → the MaldivesRide Web App row → Register
 *   2. Choose reCAPTCHA Enterprise; create a key in Google Cloud Console with
 *      maldivesride-1536a.web.app and maldivesride-1536a.firebaseapp.com as
 *      allowed domains (add localhost too if you want `npm start` to attest
 *      without the debug token below).
 *   3. Put the site key in maldivesride-admin/.env.local as
 *      REACT_APP_APPCHECK_SITE_KEY=... and rebuild.
 *
 * The site key is public by design — it ships in the page either way — so it is
 * not a secret. It lives in an env var to keep this file deployable before the
 * key exists, not to hide it.
 */
const siteKey = process.env.REACT_APP_APPCHECK_SITE_KEY;

if (process.env.NODE_ENV === 'development') {
  // Prints a debug token to the browser console on first load. Register it at
  // App Check → Apps → ⋮ → Manage debug tokens so local development attests
  // without adding localhost to the production reCAPTCHA key.
  // eslint-disable-next-line no-restricted-globals
  self.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
}

if (siteKey) {
  try {
    initializeAppCheck(app, {
      provider: new ReCaptchaEnterpriseProvider(siteKey),
      isTokenAutoRefreshEnabled: true,
    });
  } catch (e) {
    // Swallowed for the same reason the mobile app swallows its equivalent: an
    // App Check failure must never take the panel down. While services are on
    // Monitoring a missing token costs nothing, and once they are not, a hard
    // failure here would lock admin out rather than degrade.
    console.warn('[AppCheck] Admin panel attestation unavailable:', e);
  }
} else {
  console.warn(
    '[AppCheck] REACT_APP_APPCHECK_SITE_KEY is not set — the admin panel is ' +
    'sending no App Check token. Harmless while Firebase services are on ' +
    'Monitoring; it locks admin out the moment any of them is Enforced.',
  );
}

export const db = getFirestore(app);
export const auth = getAuth(app);
export const functions = getFunctions(app, 'asia-south1');
export const storage = getStorage(app);
